/*
 * File: Header.js
 * Project: recnotes
 * Created: Thursday, September 9th 2021, 6:24:42 am
 * Last Modified: Thursday, September 16th 2021, 5:18:37 am
 * Copyright © 2021 AMDE Agência
 */

import React from 'react';

const Header = () => {
  return (
    <header className="app-header">
      <h1>Notes List</h1>
    </header>
  );
};

export default Header;
